// extracted by mini-css-extract-plugin
export default {"page":"eL","freeShippingContainer":"fL","customizeContainer":"gL","customizeHeader":"hL","fadein":"iL","customizeText":"jL","hidden":"kL","productcard":"lL","accordeonscontainer":"mL","freeShipping":"nL","mainpart":"oL"};
    if(module.hot) {
      // 1730991508715
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  